import axios from 'axios';
import merge from 'lodash-es/merge';

/**
 * DescriptionPagesService
 */
export default class DescriptionPagesService
{
    public static path = 'admin/wk/description-pages';

    /**
     * @param filter FilterModel
     * @param pager Pager
     * @param except number[]
     *
     * @returns Promise<Pagination<Resource<ListItemModel>>>
     */
    public static async getList(filter: FilterModel, pager: Pager, except: number[] = []): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`${this.path}`, {
            params: merge({}, filter, pager.data(), { except: except })
        })).data;
    }

    /**
     * @param id number
     *
     * @returns Promise<Resource<FormModel>>
     */
    public static async fetch(id: number): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`${this.path}/${id}`)).data;
    }

    /**
     * @param id number
     * @param model UpsertModel
     *
     * @returns Promise<Statement>
     */
    public static async create(model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.post(`${this.path}`, model)).data as Resource<FormModel>;
    }

    /**
     * @param id number
     * @param model UpsertModel
     *
     * @returns Promise<Statement>
     */
    public static async update(id: number, model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.put(`${this.path}/${id}`, model)).data as Resource<FormModel>;
    }

    /**
     * @param id number
     *
     * @returns Promise<Statement>
     */
    public static async remove(id: number): Promise<Statement>
    {
        return (await axios.delete(`${this.path}/${id}`)).data as Statement;
    }

    /**
     * @param search string
     * @param limit number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getAutocompleteList(search: string, limit: number = 10): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    /**
    * @param id number
    *
    * @returns Promise<ListItemModel>
    */
    public static async fetchAutocompleteModel(id: number): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`${this.path}/autocomplete/${id}`)).data;
    }
}

export interface ListItemModel
{
    id: number;
    title: string;
    isPublished: boolean;
}

export interface UpsertModel
{
    id: number;
    title: string;
    content: string;
    isPublished: boolean;
}

export interface FormModel extends UpsertModel
{
}

export interface FilterModel
{
    title: string;
    isPublished: boolean;
}
